<template>
  <c-input-container
    v-bind="$attrs"
    class="c-checkbox"
  >
    <label
      class="checkbox"
      :class="{
        '-active': internalValue
      }"
    >
      <input
        v-show="false"
        type="checkbox"
        v-model="internalValue"
      />
    </label>

    <div
      class="text"
      v-if="$slots.default"
    >
      <slot />
    </div>
  </c-input-container>
</template>

<script>
export default {
  props: {
    value: [Boolean, Number]
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    internalValue (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

$c-checkbox-size: 20px;

.c-checkbox {
  display: flex;
  flex-flow: row wrap;

  & > .checkbox {
    height: $c-checkbox-size;
    width: $c-checkbox-size;
    flex: $c-checkbox-size 0 0;
    border: 1px solid $border-color;
    border-radius: 2px;
    position: relative;
    background-color: white;
    display: inline-block;

    &:before {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: $secondary-color-placeholder;
      background-color: var(--color-secondary);
      height: 0px;
      width: 0px;
      border-radius: 2px;
      transition: height .15s ease,
        width .15s ease;
    }

    &.-active:before {
      height: 12px;
      width: 12px;
    }
  }

  & > .text {
    font-size: 12px;
    margin-left: 20px;
    color: $text-color;
    flex: 1 1 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CCheckbox.vue